import { Breakpoint, Color, FontWeight } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { ContentMaxWidth } from '../../theme';

export const Container = styled.div`
  background-color: ${Color.Gray100};

  @media ${Breakpoint.Tablet} {
    padding: 0 80px;
  }
`;

export const Wrapper = styled.div`
  max-width: ${ContentMaxWidth};
  margin: 0 auto;
  padding: 60px 0;
`;

export const Header = styled.h4`
  color: ${Color.Black100};
  font-weight: ${FontWeight.Bold};
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 30px;
  margin-left: 20px;

  @media ${Breakpoint.Tablet} {
    margin-left: 0;
  }
`;

export const LoadMoreSentinel = styled.div``;
